import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'clmtlk-sticky-menu',
  templateUrl: './menu-bar.component.html',
  styleUrls: ['./menu-bar.component.scss']
})
export class MenuBarComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/CLAIMS_PIPELINE/CLMTLK_UI_APP_PIPELINE/src/app/clmtlk/shared/component/menu-bar/menu-bar.component.ts